class BookingDokter {
  constructor (data) {
    Object.assign(this, data)
  }
}

export default BookingDokter
